import asyncComponent from 'components/Router/AsyncComponent';
import reducer from './reducer';

export default asyncComponent(() => import('./container'), reducer, 'route_invites');
